<template>
  <v-row class="fill-height pa-0 ma-0">
    <v-col cols="12" lg="12"
           class="d-flex justify-start align-start fill-height flex-column mx-auto pa-lg-10">
      <v-card tile width="33%">
        <validation-observer ref="userForm" v-slot="{ passes }">
          <v-form @submit.prevent="passes(submit)">
            <v-card-title>{{ $t('addNewUser.title') }}</v-card-title>
            <v-card-subtitle>{{ $t('addNewUser.subtitle') }}</v-card-subtitle>
            <v-card-text>
              <validation-provider :name="$t('addNewUser.form.name.label')"
                                   rules="required"
                                   v-slot="{ errors }">
                <v-text-field :error-messages="errors"
                              v-model="form.name"
                              :label="$t('addNewUser.form.name.label')"
                              :placeholder="$t('addNewUser.form.name.placeholder')"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('addNewUser.form.email.label')"
                                   rules="required|email"
                                   v-slot="{ errors }">
                <v-text-field :error-messages="errors"
                              type="email"
                              v-model="form.email"
                              :label="$t('addNewUser.form.email.label')"
                              :placeholder="$t('addNewUser.form.email.placeholder')"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('addNewUser.form.password.label')"
                                   rules="required"
                                   v-slot="{ errors }">
                <v-text-field :error-messages="errors"
                              type="password"
                              v-model="form.password"
                              :label="$t('addNewUser.form.password.label')"
                              :placeholder="$t('addNewUser.form.password.placeholder')"></v-text-field>
              </validation-provider>
              <validation-provider :name="$t('addNewUser.form.role.label')"
                                   rules="required"
                                   v-slot="{ errors }">
                <v-select :error-messages="errors"
                          :items="$t('addNewUser.roles')"
                          :label="$t('addNewUser.form.role.label')"
                          :placeholder="$t('addNewUser.form.role.placeholder')"
                          v-model="form.role"
                          item-value="value"
                          item-text="text"></v-select>
              </validation-provider>
            </v-card-text>
            <v-card-actions class="pl-4 pb-4 pt-0">
              <v-btn type="submit" tile color="primary" dark>{{ $t('addNewUser.submit') }}</v-btn>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "User",
  data () {
    return {
      form: {
        name: null,
        email: null,
        role: null,
        password: null
      }
    }
  },
  methods: {
    submit () {
      console.log(this.form)
      this.$http.post('api/v2/auth/register', this.form)
          .then(() => {
            this.form = this.$worker.resetForm(this.form);
            this.$refs.userForm.reset()
          })
    }
  }
}
</script>

<style scoped>

</style>
